/**
 * Настройки из нового макета главного экрана, которых пока нет в рендере.
 * Они видны и переключаются в интерфейсе, но живут только в состоянии экрана:
 * в ProjectSettings и на сервер не попадают. Когда рендер научится их
 * применять, значения переезжают в @reels/shared/constants и схему настроек.
 */

/** Цвета подсветки, которых ещё нет в HIGHLIGHT_COLORS. */
export const UPCOMING_HIGHLIGHTS = [
  { value: 'white', label: 'Белый', hex: '#FFFFFF' },
  { value: 'black', label: 'Чёрный', hex: '#0A0A0A' },
  { value: 'dakar', label: 'Дакар', hex: '#F6F2B5' },
  { value: 'cherry', label: 'Вишня', hex: '#670627' },
  { value: 'sky', label: 'Небесный', hex: '#C0D6ED' },
  { value: 'matcha', label: 'Матча', hex: '#CBDEA6' },
] as const;
export type UpcomingHighlight = (typeof UPCOMING_HIGHLIGHTS)[number]['value'];

/**
 * Порядок образцов по палитре из макета (Figma 28128:8432); белый и чёрный
 * стоят первыми, как на макете главного экрана.
 */
export const HIGHLIGHT_ORDER = [
  'white', 'black', 'dakar', 'lemon', 'amber', 'orange', 'coral', 'cherry', 'pink',
  'violet', 'azure', 'sky', 'turquoise', 'lime', 'mint', 'matcha',
] as const;
